import { useEffect } from 'react'
import { useFixedAssetsSyncStore } from '@/store/fixedAssetsSyncStore'

const POLL_INTERVAL_MS = 30_000

/**
 * Keeps the fixed-assets sync error count (sidebar badge) fresh.
 * Mounted once from App. Refetches on an interval without refresh=true.
 */
export function useFixedAssetsSyncPoller() {
  const fetchLatest = useFixedAssetsSyncStore((s) => s.fetchLatest)

  useEffect(() => {
    void fetchLatest()
  }, [fetchLatest])

  useEffect(() => {
    const interval = setInterval(() => {
      void fetchLatest()
    }, POLL_INTERVAL_MS)
    return () => clearInterval(interval)
  }, [fetchLatest])
}
